import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PageHero, CTABand } from "../components/site/Blocks";
import { INDUSTRIES } from "../data/content";

const Selector = () => {
  const [active, setActive] = useState(INDUSTRIES[0].key);
  const ind = INDUSTRIES.find((x) => x.key === active);
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="industries-selector">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-[var(--muted)]">Select a sector</p>
          <div className="mt-6 flex flex-col border-t border-black/15">
            {INDUSTRIES.map((x, i) => (
              <button
                key={x.key}
                onClick={() => setActive(x.key)}
                data-testid={`industry-tab-${x.key}`}
                className={`group flex items-center gap-4 border-b border-black/15 py-5 text-left text-2xl font-semibold tracking-tight transition-colors sm:text-3xl ${active === x.key ? "text-[var(--ink)]" : "text-[var(--muted)] hover:text-[var(--ink)]"}`}
              >
                <span className="font-mono text-xs font-normal">0{i + 1}</span>
                {x.name}
                {active === x.key && <motion.span layoutId="ind-dot" className="ml-auto h-3 w-3 rounded-full bg-[var(--cobalt)]" />}
              </button>
            ))}
          </div>
        </div>
        <div className="relative min-h-[420px] lg:col-span-6 lg:col-start-7">
          <AnimatePresence initial={false}>
            <motion.div
              key={ind.key}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16, position: "absolute" }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="inset-x-0 top-0 rounded-[4px] bg-[var(--ink)] p-8 text-[var(--paper)] sm:p-12"
              data-testid="industry-detail"
            >
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-zinc-400">Sector focus</p>
              <h2 className="mt-6 text-4xl font-semibold tracking-[-0.03em] sm:text-5xl">{ind.name}</h2>
              <p className="mt-5 text-lg leading-relaxed text-zinc-300">{ind.text}</p>
              <p className="mt-12 font-mono text-xs uppercase tracking-[0.22em] text-zinc-400">Typical use cases</p>
              <ul className="mt-4 space-y-3">
                {ind.cases.map((c) => (
                  <li key={c} className="flex items-center justify-between border-b border-white/15 pb-3 text-xl">
                    <span className="font-serif-i text-2xl">{c}</span>
                    <span className="h-2 w-2 rotate-45 bg-[var(--cobalt)]" />
                  </li>
                ))}
              </ul>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default function Industries() {
  return (
    <main data-testid="industries-page">
      <PageHero
        testid="industries-hero"
        label="Industries"
        lines={["Sector-specific", <span className="font-serif-i">intelligence.</span>]}
        intro="Every market has its own language. Our domain experts speak it fluently, so your research asks the right questions of the right people."
      />
      <Selector />
      <CTABand />
    </main>
  );
}
